import type { CloudPC, CloudPCDetail, Snapshot, OperationRecord, CloudDisk } from './types';

export const mockCloudPCs: CloudPC[] = [
  {
    id: 'CPC-20240101-001',
    name: '开发环境主机',
    productName: '标准云电脑',
    userName: '张三',
    userPhone: '13800138001',
    userId: 'U001',
    cpu: 8,
    memory: 16,
    systemDisk: 100,
    gpu: 'RTX 3060',
    os: 'Windows 11',
    status: 'running',
    purchaseType: 'monthly',
    purchaseDetail: '240小时/月 + 3月',
    expireTime: '2024-04-01 23:59:59',
    remainingTime: '45天12小时',
    totalTime: '90天',
    internalIp: '192.168.1.10',
    publicIp: '120.78.123.45',
    cpuUsage: 45,
    memoryUsage: 62,
    diskUsage: 38,
    createTime: '2024-01-01 10:30:00',
    datacenter: '北京数据中心',
    server: 'BJ-SRV-001',
    isOverdue: false,
  },
  {
    id: 'CPC-20240102-002',
    name: '测试服务器',
    productName: '高性能云电脑',
    userName: '李四',
    userPhone: '13800138002',
    userId: 'U002',
    cpu: 16,
    memory: 32,
    systemDisk: 200,
    gpu: 'RTX 4090',
    os: 'Ubuntu 22.04',
    status: 'running',
    purchaseType: 'hourly',
    purchaseDetail: '计时付费',
    expireTime: '2024-03-15 18:30:00',
    remainingTime: '18小时',
    totalTime: '无限制',
    internalIp: '192.168.1.11',
    publicIp: '120.78.123.46',
    cpuUsage: 78,
    memoryUsage: 85,
    diskUsage: 56,
    createTime: '2024-01-02 14:20:00',
    datacenter: '上海数据中心',
    server: 'SH-SRV-003',
    isOverdue: false,
  },
  {
    id: 'CPC-20240103-003',
    name: '办公电脑',
    productName: '标准云电脑',
    userName: '王五',
    userPhone: '13800138003',
    userId: 'U003',
    cpu: 4,
    memory: 8,
    systemDisk: 80,
    os: 'Windows 10',
    status: 'stopped',
    purchaseType: 'package',
    purchaseDetail: '30天 100小时 + 09:00-18:00',
    expireTime: '2024-02-03 23:59:59',
    remainingTime: '15天',
    totalTime: '30天',
    createTime: '2024-01-03 09:00:00',
    datacenter: '深圳数据中心',
    server: 'SZ-SRV-005',
    isOverdue: false,
  },
  {
    id: 'CPC-20240104-004',
    name: 'AI训练主机',
    productName: 'GPU服务器',
    userName: '赵六',
    userPhone: '13800138004',
    userId: 'U004',
    cpu: 32,
    memory: 64,
    systemDisk: 500,
    gpu: 'A100 80GB',
    os: 'Ubuntu 20.04',
    status: 'running',
    purchaseType: 'monthly',
    purchaseDetail: '不限时长 + 6月',
    expireTime: '2024-07-04 23:59:59',
    remainingTime: '180天',
    totalTime: '180天',
    internalIp: '192.168.1.12',
    publicIp: '120.78.123.47',
    cpuUsage: 92,
    memoryUsage: 88,
    diskUsage: 72,
    createTime: '2024-01-04 11:15:00',
    datacenter: '北京数据中心',
    server: 'BJ-SRV-002',
    isOverdue: false,
  },
  {
    id: 'CPC-20240105-005',
    name: '渲染工作站',
    productName: '高性能云电脑',
    userName: '孙七',
    userPhone: '13800138005',
    userId: 'U005',
    cpu: 16,
    memory: 32,
    systemDisk: 300,
    gpu: 'RTX 3090',
    os: 'Windows 11',
    status: 'creating',
    purchaseType: 'hourly',
    purchaseDetail: '计时付费',
    expireTime: '2024-03-20 10:00:00',
    remainingTime: '计算中',
    totalTime: '无限制',
    createTime: '2024-01-05 16:45:00',
    datacenter: '广州数据中心',
    server: 'GZ-SRV-001',
    isOverdue: false,
  },
  {
    id: 'CPC-20240106-006',
    name: '数据分析服务器',
    productName: '标准云电脑',
    userName: '周八',
    userPhone: '13800138006',
    userId: 'U006',
    cpu: 8,
    memory: 16,
    systemDisk: 150,
    os: 'CentOS 7',
    status: 'fault',
    purchaseType: 'monthly',
    purchaseDetail: '200小时/月 + 1月',
    expireTime: '2024-02-06 23:59:59',
    remainingTime: '30天',
    totalTime: '30天',
    createTime: '2024-01-06 08:30:00',
    datacenter: '上海数据中心',
    server: 'SH-SRV-004',
    isOverdue: false,
  },
  {
    id: 'CPC-20240107-007',
    name: '备用主机',
    productName: '标准云电脑',
    userName: '吴九',
    userPhone: '13800138007',
    userId: 'U007',
    cpu: 4,
    memory: 8,
    systemDisk: 80,
    os: 'Windows 10',
    status: 'expired',
    purchaseType: 'package',
    purchaseDetail: '15天 50小时',
    expireTime: '2024-01-22 23:59:59',
    remainingTime: '已过期',
    totalTime: '15天',
    createTime: '2024-01-07 12:00:00',
    datacenter: '深圳数据中心',
    server: 'SZ-SRV-006',
    isOverdue: true,
  },
  {
    id: 'CPC-20240108-008',
    name: '游戏测试机',
    productName: 'GPU服务器',
    userName: '郑十',
    userPhone: '13800138008',
    userId: 'U008',
    cpu: 12,
    memory: 24,
    systemDisk: 200,
    gpu: 'RTX 4070',
    os: 'Windows 11',
    status: 'running',
    purchaseType: 'monthly',
    purchaseDetail: '240小时/月 + 2月',
    expireTime: '2024-03-08 23:59:59',
    remainingTime: '60天',
    totalTime: '60天',
    internalIp: '192.168.1.13',
    publicIp: '120.78.123.48',
    cpuUsage: 55,
    memoryUsage: 68,
    diskUsage: 45,
    createTime: '2024-01-08 15:20:00',
    datacenter: '北京数据中心',
    server: 'BJ-SRV-003',
    isOverdue: false,
  },
];

export const mockCloudPCDetail: CloudPCDetail = {
  ...mockCloudPCs[0],
  imageVersion: 'Windows 11 Pro 22H2',
  physicalServerId: 'PHY-BJ-001',
  totalRunningTime: '720小时30分钟',
  releaseTime: '2024-04-08 23:59:59',
  cpuModel: 'Intel Xeon Gold 6248R',
  memoryType: 'DDR4 ECC',
  diskType: 'NVMe SSD',
  gpuMemory: '12GB GDDR6',
  bandwidth: '上行100Mbps / 下行100Mbps',
};

export const mockSnapshots: Snapshot[] = [
  {
    id: 'SNAP-001',
    name: '系统初始化快照',
    size: '45.2 GB',
    createTime: '2024-01-01 11:00:00',
  },
  {
    id: 'SNAP-002',
    name: '开发环境配置完成',
    size: '52.8 GB',
    createTime: '2024-01-15 16:30:00',
  },
  {
    id: 'SNAP-003',
    name: '项目部署前备份',
    size: '68.5 GB',
    createTime: '2024-02-01 09:45:00',
  },
];

export const mockOperationRecords: OperationRecord[] = [
  {
    time: '2024-03-10 14:30:25',
    type: '启动',
    operator: '张三（用户）',
    result: '成功',
    remark: '用户手动启动',
  },
  {
    time: '2024-03-10 10:15:10',
    type: '关机',
    operator: '张三（用户）',
    result: '成功',
    remark: '用户手动关机',
  },
  {
    time: '2024-03-09 18:20:35',
    type: '重启',
    operator: '系统管理员',
    result: '成功',
    remark: '系统维护重启',
  },
  {
    time: '2024-03-08 16:45:50',
    type: '创建快照',
    operator: '张三（用户）',
    result: '成功',
    remark: '项目部署前备份',
  },
  {
    time: '2024-03-05 11:30:15',
    type: '扩容',
    operator: '系统管理员',
    result: '成功',
    remark: '内存从8GB扩容至16GB',
  },
];

export const mockCloudDisks: CloudDisk[] = [
  {
    id: 'CD-20240101-001',
    name: '数据盘-001',
    userId: 'U001',
    userPhone: '13800138001',
    storageType: 'SSD',
    usedStorage: 320,
    totalStorage: 500,
    internalIp: '192.168.1.20',
    createTime: '2024-01-01 10:30:00',
    expireTime: '2024-07-01 23:59:59',
    datacenter: '北京数据中心',
    server: 'BJ-SRV-001',
    isOverdue: false,
    status: 'normal',
  },
  {
    id: 'CD-20240102-002',
    name: '备份数据盘',
    userId: 'U002',
    userPhone: '13800138002',
    storageType: 'SSD',
    usedStorage: 850,
    totalStorage: 1000,
    internalIp: '192.168.1.21',
    createTime: '2024-01-02 14:20:00',
    expireTime: '2024-04-02 23:59:59',
    datacenter: '上海数据中心',
    server: 'SH-SRV-003',
    isOverdue: false,
    status: 'normal',
  },
  {
    id: 'CD-20240103-003',
    name: '项目数据盘',
    userId: 'U003',
    userPhone: '13800138003',
    storageType: 'SSD',
    usedStorage: 150,
    totalStorage: 300,
    internalIp: '192.168.1.22',
    createTime: '2024-01-03 09:00:00',
    expireTime: '2024-03-03 23:59:59',
    datacenter: '深圳数据中心',
    server: 'SZ-SRV-005',
    isOverdue: false,
    status: 'normal',
  },
  {
    id: 'CD-20240104-004',
    name: 'AI模型存储',
    userId: 'U004',
    userPhone: '13800138004',
    storageType: 'SSD',
    usedStorage: 1800,
    totalStorage: 2000,
    internalIp: '192.168.1.23',
    createTime: '2024-01-04 11:15:00',
    expireTime: '2024-10-04 23:59:59',
    datacenter: '北京数据中心',
    server: 'BJ-SRV-002',
    isOverdue: false,
    status: 'normal',
  },
  {
    id: 'CD-20240105-005',
    name: '渲染素材盘',
    userId: 'U005',
    userPhone: '13800138005',
    storageType: 'SSD',
    usedStorage: 450,
    totalStorage: 800,
    internalIp: '192.168.1.24',
    createTime: '2024-01-05 16:45:00',
    expireTime: '2024-05-05 23:59:59',
    datacenter: '广州数据中心',
    server: 'GZ-SRV-001',
    isOverdue: false,
    status: 'disabled',
  },
  {
    id: 'CD-20240106-006',
    name: '日志存储盘',
    userId: 'U006',
    userPhone: '13800138006',
    storageType: 'SSD',
    usedStorage: 95,
    totalStorage: 200,
    internalIp: '192.168.1.25',
    createTime: '2024-01-06 08:30:00',
    expireTime: '2024-02-20 23:59:59',
    releaseTime: '2024-02-27 23:59:59',
    datacenter: '上海数据中心',
    server: 'SH-SRV-004',
    isOverdue: true,
    status: 'normal',
  },
];
